export const loadAvatarImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image()
    if (!src.startsWith('data:') && !src.startsWith('blob:')) {
      img.crossOrigin = 'anonymous'
    }
    img.onload = () => resolve(img)
    img.onerror = () => reject(new Error('Failed to load avatar image'))
    img.src = src
  })

export const getImageSize = (image) => ({
  width: Math.max(1, Number(image?.naturalWidth || image?.width || 1)),
  height: Math.max(1, Number(image?.naturalHeight || image?.height || 1))
})
